import { TFunction } from 'i18next'

import { TransactionsDaybooksActionItem } from '../types/daybooksActionItem'

export enum TransactionsDaybooksActionType {
  Void = 'void',
  Reverse = 'reverse',
  CopyToDaybook = 'copy_to_daybook',
}

interface GetDaybooksActionsProps {
  hasDaybookReference?: boolean
  isVoided?: boolean
  t: TFunction
}

export const getDaybooksActions = ({ hasDaybookReference, isVoided, t }: GetDaybooksActionsProps) => {
  const items: TransactionsDaybooksActionItem[] = []

  if (!isVoided) {
    items.push({
      children: t('transactions.table.static_actions.daybook.void'),
      id: TransactionsDaybooksActionType.Void,
      value: TransactionsDaybooksActionType.Void,
    })

    if (hasDaybookReference) {
      items.push({
        children: t('transactions.table.static_actions.daybook.reverse'),
        id: TransactionsDaybooksActionType.Reverse,
        value: TransactionsDaybooksActionType.Reverse,
      })
    }
  }

  if (hasDaybookReference) {
    items.push({
      children: t('transactions.table.static_actions.daybook.copy_to_daybook'),
      id: TransactionsDaybooksActionType.CopyToDaybook,
      value: TransactionsDaybooksActionType.CopyToDaybook,
    })
  }

  return items
}
